import React from "react";
import { Outlet } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { ToolsLayout } from "./ToolsLayout";

import { useContentVisit } from "../stats/useContentVisit";
import { toolDefinitions } from "./toolDefinitions";

export default function ToolSite() {
  useContentVisit("tools", toolDefinitions);
  useTitle("Tools");
  return (
    <ToolsLayout>
      <Outlet />
    </ToolsLayout>
  );
}
